import dayjs from "dayjs";
import { CashHead } from "../../../api/ProjectCash";

export interface CashHeadMeta {
  code: CashHead;
  /** Tab label + the 'Head' cell text in the Excel template. */
  label: string;
  flow: "Inflow" | "Outflow";
  /** Form/table label for referenceNo. */
  referenceLabel: string;
}

export const CASH_HEADS: CashHeadMeta[] = [
  { code: "RA_BILL", label: "RA Bill", flow: "Inflow", referenceLabel: "Bill No." },
  { code: "ESCALATION", label: "Escalation", flow: "Inflow", referenceLabel: "Reference" },
  { code: "SITE_EXPENSE", label: "Site Expenses", flow: "Outflow", referenceLabel: "Reference" },
  { code: "SALARY", label: "Salaries", flow: "Outflow", referenceLabel: "Reference" },
];

export const cashHeadMeta = (head?: string): CashHeadMeta | undefined =>
  CASH_HEADS.find(
    (h) =>
      h.code === head ||
      h.label.toLowerCase() === String(head || "").trim().toLowerCase()
  );

/** 'YYYY-MM-01' | 'YYYY-MM' → 'Jul 2026' */
export const fmtCashMonth = (month?: string): string => {
  if (!month) return "—";
  const d = dayjs(month.length === 7 ? `${month}-01` : month);
  return d.isValid() ? d.format("MMM YYYY") : month;
};

/** 'YYYY-MM-DD' → '12 Jul 2026' */
export const fmtCashDate = (date?: string): string => {
  if (!date) return "—";
  const d = dayjs(date);
  return d.isValid() ? d.format("DD MMM YYYY") : date;
};
